const STORAGE_KEY = 'sololine_auth_token';
const EXPIRES_AT_KEY = 'sololine_auth_token_expires_at';

export const getAuthToken = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const getAuthTokenExpiresAt = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(EXPIRES_AT_KEY);
  } catch {
    return null;
  }
};

export const setAuthToken = (token, expiresAt = null) => {
  if (typeof window === 'undefined') return;
  try {
    if (!token) {
      window.localStorage.removeItem(STORAGE_KEY);
      window.localStorage.removeItem(EXPIRES_AT_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, token);
      if (expiresAt) {
        window.localStorage.setItem(EXPIRES_AT_KEY, expiresAt);
      }
    }
  } catch {
    // ignore storage errors
  }
};

export const setAuthSession = ({ token, expires_at: expiresAt } = {}) => {
  setAuthToken(token, expiresAt);
};

export const clearAuthToken = () => setAuthToken(null);
